





















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class StListItemHeader extends Vue {
    @Prop() icon!: string;

    get subheader() {
        return this.$slots.subheader;
    }
}
